import React, {Component} from "react"
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import {store} from "../App";
import { setHideHeaderLinks } from "../Redux/OverlayActions";
import LanguageSelector from "./Header/LanguageSelector";
import HeaderMenu from "./Header/HeaderMenu";
import HamburgerButton from "./Header/HamburgerButton";

const updateBarStyle = {
    backgroundColor: process.env.REACT_APP_THEME_COLOR,
    textAlign: "center",
    color: process.env.REACT_APP_THEME_TEXT_COLOR,
    padding: "0.25rem",
    display: "none",
    zIndex: "1030",
}

class Header extends Component {
    constructor() {
        super();
        this.state = {
            expanded : false
        };
        this.toggleExpanded = this.toggleExpanded.bind(this);
        this.closeExpanded = this.closeExpanded.bind(this);
        this.checkConsent = this.checkConsent.bind(this);
    }

    componentDidMount() {
        this.checkConsent();
    }

    checkConsent() {
        const consent = (window.localStorage.getItem('consent') || false);
        store.dispatch(setHideHeaderLinks(!consent));
    }

    toggleExpanded()
    {
        this.setState(prevState => ({expanded : !prevState.expanded}));
    }

    closeExpanded(){
        this.setState({expanded : false});
        // Also close the Bootstrap collapse programmatically
        const navbarCollapse = document.getElementById('navbarNavAltMarkup');
        if (navbarCollapse && navbarCollapse.classList.contains('show')) {
            navbarCollapse.classList.remove('show');
        }
    }
    
    render() {
        if (this.props.hideHeader) {
            return null;
        }

        const overlay = (this.state.expanded ? <div onClick={this.closeExpanded} data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" className="dark-overlay"></div> : <div></div>);
        const menuItems = (!this.props.hideHeaderLinks ?
            <div className="header-nav-container">
                <LanguageSelector />
                <HamburgerButton
                    isOpen={this.state.expanded}
                    onClick={this.toggleExpanded}
                />
                <HeaderMenu closeExpanded={this.closeExpanded} />
            </div>
        : null);
        return (
            <div className="fixed-top">
                <div id="updateBar" style={updateBarStyle}>
                    <button type="button" id="updateBarReload" style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0}}>Er is een nieuwe versie van de app beschikbaar. Klik hier om te updaten.</button>
                </div>
                <nav className="navbar navbar-expand-lg navbar-light" style={{zIndex: "1030"}}>
                    <div className="container">
                        <Link className="navbar-brand" to="/"><img id="logo" alt="logo foubert" src={window.location.origin + '/images/logo.png'}/></Link>
                        {menuItems}
                    </div>
                </nav>
                {overlay}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        hideHeader: state.overlay.hideHeader || false,
        hideHeaderLinks: state.overlay.hideHeaderLinks || false,
    }
}

export default connect(mapStateToProps)(Header);